// extracted by mini-css-extract-plugin
export var active = "DoorProgressIndicator-module--active--d6d57";
export var checkmarkImage = "DoorProgressIndicator-module--checkmarkImage--2f036";
export var clickable = "DoorProgressIndicator-module--clickable--4abac";
export var completed = "DoorProgressIndicator-module--completed--877ca";
export var container = "DoorProgressIndicator-module--container--d94ef";
export var disabled = "DoorProgressIndicator-module--disabled--d62f2";
export var inactive = "DoorProgressIndicator-module--inactive--d99c8";
export var stepBarCompleted = "DoorProgressIndicator-module--stepBarCompleted--09bf9";
export var stepCircle = "DoorProgressIndicator-module--stepCircle--5cfe2";
export var stepsContainer = "DoorProgressIndicator-module--stepsContainer--1d5d6";
export var text = "DoorProgressIndicator-module--text--241fb";
export var textContainer = "DoorProgressIndicator-module--textContainer--04682";
export var textHighlighted = "DoorProgressIndicator-module--textHighlighted--f7680";